import axios from 'axios';
import {apiService} from "../../services/api.service";
import {extractData, handleResponse} from "../../helpers/apiResponseHelper";

export const InventoryService = {
    getInventoryData: getInventoryData
};

async function getInventoryData(customerId: number | null) {
    if (customerId == null) {
        return [];
    }

    return axios.get(apiService.getApiUrl() + '/inventory/' + customerId)
        .then(handleResponse).then(extractData);
}